"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoMarkerChangeNotificationSchema = void 0;
exports.VideoMarkerChangeNotificationSchema = {
    "$id": "https://www.redbull.com/schemas/change-notifications/video-markers.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "VideoMarkerChangeNotification",
    "description": "Change notification sent out when a video marker is changed",
    "type": "object",
    "properties": {
        "correlationId": {
            "description": "The correlation ID is a unique identifier that is added to incoming request in order to identify the context and is passed to all components that are involved in the transaction flow.",
            "type": "string",
            "pattern": "^[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}$"
        },
        "action": {
            "description": "The action field contains the operation leading to the video marker change. For details, see https://api.developers.redbull.com/docs/resource-change-notifications#video-marker-changes",
            "type": "string"
        },
        "resource": {
            "description": "The resource field contains the video marker that has been changed. For details, see https://api.developers.redbull.com/docs/resource-change-notifications#video-marker-changes",
            "$ref": "https://www.redbull.com/schemas/video-markers.schema.json"
        }
    },
    "additionalProperties": false,
    "required": [
        "correlationId",
        "action",
        "resource"
    ]
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW8tbWFya2Vycy5zY2hlbWEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvbW9kdWxlcy9jaGFuZ2Utbm90aWZpY2F0aW9ucy92aWRlby1tYXJrZXJzLnNjaGVtYS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLG1DQUFtQyxHQUFHO0lBQ2pELEtBQUssRUFBRSxnRkFBZ0Y7SUFDdkYsU0FBUyxFQUFFLDhDQUE4QztJQUN6RCxPQUFPLEVBQUUsK0JBQStCO0lBQ3hDLGFBQWEsRUFBRSw2REFBNkQ7SUFDNUUsTUFBTSxFQUFFLFFBQVE7SUFDaEIsWUFBWSxFQUFFO1FBQ1osZUFBZSxFQUFFO1lBQ2YsYUFBYSxFQUFFLHlMQUF5TDtZQUN4TSxNQUFNLEVBQUUsUUFBUTtZQUNoQixTQUFTLEVBQUUsbURBQW1EO1NBQy9EO1FBQ0QsUUFBUSxFQUFFO1lBQ1IsYUFBYSxFQUFFLHlMQUF5TDtZQUN4TSxNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELFVBQVUsRUFBRTtZQUNWLGFBQWEsRUFBRSxpTEFBaUw7WUFDaE0sTUFBTSxFQUFFLDJEQUEyRDtTQUNwRTtLQUNGO0lBQ0Qsc0JBQXNCLEVBQUUsS0FBSztJQUM3QixVQUFVLEVBQUU7UUFDVixlQUFlO1FBQ2YsUUFBUTtRQUNSLFVBQVU7S0FDWDtDQUNGLENBQUEifQ==